import { success as successNotif, error as errorNotif } from "react-notification-system-redux";

import { credentialsService } from "_services";

import { credentialsTypes } from "../types";

export const credentialsActions = {
  getCredentials,
  setCredentials,
};

function getCredentials() {
  return (dispatch) => {
    dispatch(request());

    credentialsService.getCredentials().then(
      (credentials) => dispatch(success(credentials)),
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: credentialsTypes.GET_CREDENTIALS_REQUEST };
  }

  function success(payload) {
    return { type: credentialsTypes.GET_CREDENTIALS_SUCCESS, payload };
  }

  function failure() {
    return { type: credentialsTypes.GET_CREDENTIALS_FAILURE };
  }
}

function setCredentials({ brandCategory, username, password, oldPassword }) {
  return (dispatch) => {
    dispatch(request());

    credentialsService.setCredentials({ brandCategory, username, password, oldPassword }).then(
      () => {
        dispatch(
          successNotif({
            title: "Success",
            message: `Password has been changed.`,
          })
        );
        dispatch(success());
      },
      (error) => {
        dispatch(
          errorNotif({
            title: "Error",
            message: error.toString(),
          })
        );
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: credentialsTypes.POST_CREDENTIALS_REQUEST };
  }

  function success() {
    return { type: credentialsTypes.POST_CREDENTIALS_SUCCESS };
  }

  function failure() {
    return { type: credentialsTypes.POST_CREDENTIALS_FAILURE };
  }
}
